(function(){

var method;
var noop=function(){};
var methods=[
'assert','clear','count','debug','dir','dirxml','error',
'exception','group','groupCollapsed','groupEnd','info','log',
'markTimeline','profile','profileEnd','table','time','timeEnd',
'timeline','timelineEnd','timeStamp','trace','warn'];

var length=methods.length;
var console=window.console=window.console||{};

while(length--){
method=methods[length];


if(!console[method]){
console[method]=noop;
}
}


try{
if(!Object.prototype.__defineGetter__&&
Object.defineProperty({},'x',{get:function(){return!0}}).x){
Object.defineProperty(Object.prototype,'__defineGetter__',
{enumerable:!1,configurable:!0,
value:function(name,func)
{Object.defineProperty(this,name,
{get:func,enumerable:!0,configurable:!0});
}});
Object.defineProperty(Object.prototype,'__defineSetter__',
{enumerable:!1,configurable:!0,
value:function(name,func)
{Object.defineProperty(this,name,
{set:func,enumerable:!0,configurable:!0});
}});
}
}catch(defPropException){console.log('Error shimming __defineGetter__ and __defineSetter__')};

var BrowserDetect={
init:function(){
this.browser=this.searchString(this.dataBrowser)||'An unknown browser';
this.version=this.searchVersion(navigator.userAgent)||
this.searchVersion(navigator.appVersion)||
'an unknown version';
this.OS=this.searchString(this.dataOS)||'an unknown OS';
},
searchString:function(data){
for(var i=0;i<data.length;i++){
var dataString=data[i].string;
var dataProp=data[i].prop;
this.versionSearchString=data[i].versionSearch||data[i].identity;
if(dataString){
if(dataString.indexOf(data[i].subString)!=-1)
return data[i].identity;
}else
if(dataProp)
return data[i].identity;
}
},
searchVersion:function(dataString){
var index=dataString.indexOf(this.versionSearchString);
if(index==-1)return;
return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
},
dataBrowser:[
{
string:navigator.userAgent,
subString:'OPR',
identity:'Opera',
versionSearch:'OPR'},

{
prop:window.opera,
identity:'Opera',
versionSearch:'Version'},

{
string:navigator.userAgent,
subString:'Vivaldi',
identity:'Vivaldi',
versionSearch:'Vivaldi'},

{
string:navigator.userAgent,
subString:'Chrome',
identity:'Chrome'},

{string:navigator.userAgent,
subString:'OmniWeb',
versionSearch:'OmniWeb/',
identity:'OmniWeb'},

{
string:navigator.vendor,
subString:'Apple',
identity:'Safari',
versionSearch:'Version'},

{
string:navigator.vendor,
subString:'iCab',
identity:'iCab'},

{
string:navigator.vendor,
subString:'KDE',
identity:'Konqueror'},

{
string:navigator.userAgent,
subString:'Firefox',
identity:'Firefox'},

{
string:navigator.vendor,
subString:'Camino',
identity:'Camino'},

{
string:navigator.userAgent,
subString:'Netscape',
identity:'Netscape'},

{
string:navigator.userAgent,
subString:'MSIE',
identity:'Explorer',
versionSearch:'MSIE'},

{
string:navigator.userAgent,
subString:'Trident',
identity:'Explorer',
versionSearch:'rv'},

{
string:navigator.userAgent,
subString:'Gecko',
identity:'Mozilla',
versionSearch:'rv'},

{
string:navigator.userAgent,
subString:'Mozilla',
identity:'Netscape',
versionSearch:'Mozilla'}],


dataOS:[
{
string:navigator.platform,
subString:'Win',
identity:'Windows'},

{
string:navigator.platform,
subString:'Mac',
identity:'Mac'},

{
string:navigator.userAgent,
subString:'iPhone',
identity:'iPhone/iPod'},

{
string:navigator.platform,
subString:'Linux',
identity:'Linux'}]};









(function(window){'use strict';
if(!window.DOMException)(DOMException=function(reason){this.message=reason}).prototype=new Error;var wsRE=/[\11\12\14\15\40]/,wsIndex=0,checkIfValidClassListEntry=function(O,V){if(V==='')throw new DOMException('Failed to execute \''+O+'\' on \'DOMTokenList\': The token provided must not be empty.');if((wsIndex=V.search(wsRE))!==-1)throw new DOMException('Failed to execute \''+O+'\' on \'DOMTokenList\': '+'The token provided (\''+V[wsIndex]+'\') contains HTML space characters, which are not valid in tokens.')};

if(typeof DOMTokenList!='function')(function(window){var document=window.document,Object=window.Object,hasOwnProp=Object.prototype.hasOwnProperty;var defineProperty=Object.defineProperty,allowTokenListConstruction=0,skipPropChange=0;function DOMTokenList(){if(!allowTokenListConstruction)throw TypeError('Illegal constructor')}DOMTokenList.prototype.toString=DOMTokenList.prototype.toLocaleString=function(){return this.value};DOMTokenList.prototype.add=function(){a:for(var v=0,argLen=arguments.length,val='',ele=this[' uCL'],proto=ele[' uCLp'];v!==argLen;++v){val=arguments[v]+'',checkIfValidClassListEntry('add',val);for(var i=0,Len=proto.length,resStr=val;i!==Len;++i)if(this[i]===val)continue a;else resStr+=' '+this[i];this[Len]=val,proto.length+=1,proto.value=resStr}skipPropChange=1,ele.className=proto.value,skipPropChange=0};DOMTokenList.prototype.remove=function(){for(var v=0,argLen=arguments.length,val='',ele=this[' uCL'],proto=ele[' uCLp'];v!==argLen;++v){val=arguments[v]+'',checkIfValidClassListEntry('remove',val);for(var i=0,Len=proto.length,resStr='',is=0;i!==Len;++i)if(is){this[i-1]=this[i]}else{if(this[i]!==val){resStr+=this[i]+' '}else{is=1}}if(!is)continue;delete this[Len],proto.length-=1,proto.value=resStr}skipPropChange=1,ele.className=proto.value,skipPropChange=0};window.DOMTokenList=DOMTokenList;function whenPropChanges(){var evt=window.event,prop=evt.propertyName;if(!skipPropChange&&(prop==='className'||prop==='classList'&&!defineProperty)){var target=evt.srcElement,protoObjProto=target[' uCLp'],strval=''+target[prop];var tokens=strval.trim().split(wsRE),resTokenList=target[prop==='classList'?' uCL':'classList'];var oldLen=protoObjProto.length;a:for(var cI=0,cLen=protoObjProto.length=tokens.length,sub=0;cI!==cLen;++cI){for(var innerI=0;innerI!==cI;++innerI)if(tokens[innerI]===tokens[cI]){sub++;continue a}resTokenList[cI-sub]=tokens[cI]}for(var i=cLen-sub;i<oldLen;++i)delete resTokenList[i];if(prop!=='classList')return;skipPropChange=1,target.classList=resTokenList,target.className=strval;skipPropChange=0,resTokenList.length=tokens.length-sub}}function polyfillClassList(ele){if(!ele||!('innerHTML'in ele))throw TypeError('Illegal invocation');ele.detachEvent('onpropertychange',whenPropChanges);allowTokenListConstruction=1;try{function protoObj(){}protoObj.prototype=new DOMTokenList}finally{allowTokenListConstruction=0}var protoObjProto=protoObj.prototype,resTokenList=new protoObj;a:for(var toks=ele.className.trim().split(wsRE),cI=0,cLen=toks.length,sub=0;cI!==cLen;++cI){for(var innerI=0;innerI!==cI;++innerI)if(toks[innerI]===toks[cI]){sub++;continue a}this[cI-sub]=toks[cI]}protoObjProto.length=cLen-sub,protoObjProto.value=ele.className,protoObjProto[' uCL']=ele;if(defineProperty){defineProperty(ele,'classList',{enumerable:1,get:function(){return resTokenList},configurable:0,set:function(newVal){skipPropChange=1,ele.className=protoObjProto.value=newVal+='',skipPropChange=0;var toks=newVal.trim().split(wsRE),oldLen=protoObjProto.length;a:for(var cI=0,cLen=protoObjProto.length=toks.length,sub=0;cI!==cLen;++cI){for(var innerI=0;innerI!==cI;++innerI)if(toks[innerI]===toks[cI]){sub++;continue a}resTokenList[cI-sub]=toks[cI]}for(var i=cLen-sub;i<oldLen;++i)delete resTokenList[i]}});defineProperty(ele,' uCLp',{enumerable:0,configurable:0,writeable:0,value:protoObj.prototype});defineProperty(protoObjProto,' uCL',{enumerable:0,configurable:0,writeable:0,value:ele})}else{ele.classList=resTokenList,ele[' uCL']=resTokenList,ele[' uCLp']=protoObj.prototype}ele.attachEvent('onpropertychange',whenPropChanges)}try{window.Object.defineProperty(window.Element.prototype,'classList',{enumerable:1,get:function(val){if(!hasOwnProp.call(this,'classList'))polyfillClassList(this);return this.classList},configurable:0,set:function(val){this.className=val}})}catch(e){window[' uCL']=polyfillClassList;document.documentElement.firstChild.appendChild(document.createElement('style')).styleSheet.cssText='_*{x-uCLp:expression(!this.hasOwnProperty("classList")&&window[" uCL"](this))}'+'[class]{x-uCLp/**/:expression(!this.hasOwnProperty("classList")&&window[" uCL"](this))}'}})(window);

(function(DOMTokenListProto,testClass){if(!DOMTokenListProto.item)DOMTokenListProto.item=function(i){function NullCheck(n){return n===void 0?null:n}return NullCheck(this[i])};if(!DOMTokenListProto.toggle||testClass.toggle('a',0)!==!1)DOMTokenListProto.toggle=function(val){if(arguments.length>1)return this[arguments[1]?'add':'remove'](val),!!arguments[1];var oldValue=this.value;return this.remove(oldValue),oldValue===this.value&&(this.add(val),!0)};if(!DOMTokenListProto.replace||typeof testClass.replace('a','b')!='boolean')DOMTokenListProto.replace=function(oldToken,newToken){checkIfValidClassListEntry('replace',oldToken),checkIfValidClassListEntry('replace',newToken);var oldValue=this.value;return this.remove(oldToken),this.value!==oldValue&&(this.add(newToken),!0)};if(!DOMTokenListProto.contains)DOMTokenListProto.contains=function(value){for(var i=0,Len=this.length;i!==Len;++i)if(this[i]===value)return!0;return!1};if(!DOMTokenListProto.forEach)DOMTokenListProto.forEach=function(f){if(arguments.length===1)for(var i=0,Len=this.length;i!==Len;++i)f(this[i],i,this);else for(var i=0,Len=this.length,tArg=arguments[1];i!==Len;++i)f.call(tArg,this[i],i,this)};if(!DOMTokenListProto.entries)DOMTokenListProto.entries=function(){var nextIndex=0,that=this;return{next:function(){return nextIndex<that.length?{value:[nextIndex,that[nextIndex]],done:!1}:{done:!0}}}};if(!DOMTokenListProto.values)DOMTokenListProto.values=function(){var nextIndex=0,that=this;return{next:function(){return nextIndex<that.length?{value:that[nextIndex],done:!1}:{done:!0}}}};if(!DOMTokenListProto.keys)DOMTokenListProto.keys=function(){var nextIndex=0,that=this;return{next:function(){return nextIndex<that.length?{value:nextIndex,done:!1}:{done:!0}}}}})(window.DOMTokenList.prototype,window.document.createElement('div').classList)})(window);


if(Function.prototype.name===void 0&&Object.defineProperty!==void 0||browserName==='Explorer'){
Object.defineProperty(Function.prototype,'name',{
get:function(){
var funcNameRegex=/function\s([^(]{1,})\(/;
var results=funcNameRegex.exec(this.toString());
return results&&results.length>1?results[1].trim():'';
},
set:function(value){}});

}

if("production"==='development'){

let oldMatches=Element.prototype.webkitMatchesSelector;
function newMatches(selector){
try{
return oldMatches.call(this,selector);
}catch(err){
return!1;
}
}
Element.prototype.webkitMatchesSelector=newMatches;
}

BrowserDetect.init();


var browserName=BrowserDetect.browser;

if(browserName==='An unknown browser'){
console.log('Browser unknown, not appending browser-specific styles.');
return;
}

$('html').addClass('browser-'+browserName.replace(/\W+/g,'-').toLowerCase());
})();
//# sourceMappingURL=plugins.js.map
